import defaultState from '../../../input/border-color/default';

export default defaultState;
